var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charts-sdk-container",class:{ isCard: _vm.isCard }},[_c('charts-widget',{attrs:{"data":_vm.data,"tab-info":_vm.tabInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }